<template>
<div class="devops">
    <el-dialog
        :title='$t("devops.title")'
        :visible.sync="opendiaflag"
        :close-on-click-modal="false"
        :close-on-press-escape="false"
        :show-close="closeIcon"
        width="700px"
        v-loading="listLoading">
        <div class="topcontain">
            <span>{{$t("devops.customer")}}</span>
            <el-input class="searchinp" v-model="searchVal" :placeholder='$t("devops.placeholder")'></el-input>
            <div class="listbox">
                <ul>
                    <li v-for="(user,index) in userList" 
                    :key="user.userId" 
                    @click="selectList(user,index)"
                    :class="[index == actList ? 'active' : '']">
                        {{user.userName}}
                        <span v-if="user.careful=='1001002'">*</span>
                    </li>
                </ul>
                <div v-show="nosearch" style="text-align:center">{{$t("devops.result")}}</div>
            </div>
        </div>
        <div class="botcontain">
            <p>{{$t("devops.label")}}</p>
            <ul>
                <li v-for="(user,index) in history" 
                :key="user.userId" 
                @click="selectHis(user,index)"
                :class="[index == actHis ? 'active' : '']">
                    {{user.userName}}
                    <span v-if="user.careful=='1001002'">*</span>
                </li>
            </ul>
        </div>
        <span slot="footer" class="dialog-footer">
            <el-button type="primary" :disabled="btndisable" :loading="btnload" @click="imsure">{{$t("common.btnPrimary")}}</el-button>
        </span>
    </el-dialog>
</div>
</template>

<script>
import { get_session_cache } from "@/config/cache/cache.js"
import across from "@/config/components/across.js"
import { $http } from '@/config/api/axios'
import { Mixins } from '@/config/mixins/mixins'
export default { 
    name:'devops',
    mixins:[Mixins],
    data(){
        return{
            closeIcon:false,
            opendiaflag:false,
            searchVal:'',
            nosearch:false,
            selected:{},
            actList:-1,
            actHis:-1,
            btndisable:true,
            searchGather:[],
            userList:[],
            history:[],
            btnload:false,
            listLoading:false,
            
        }
    },
    watch:{
        searchVal(val){
            this.btndisable = true;
            this.actHis = -1;
            this.actList = -1;
            val = val.replace(/\s+/g, "")
            if(val.length>=1){
                const result = this.searchGather.filter(li=>li.userName.indexOf(val)>-1)
                this.userList = result
                this.nosearch = result.length === 0
            }
            if(val.length === 0){
                this.userList = this.searchGather
                this.nosearch = false;
            }
        }
    },
    methods:{
        imsure(){
            this.btnload = true;
            $http("get", "opsPerson/customerIdForOps",{customerId:this.selected.userId})
            .then((res)=>{
                this.btnload = false;
                if(res.status === 'SUCCESS'){
                    this.putHistory(this.selected)
                    if(this.userList.length === 1 && !!localStorage.getItem(`consumer_${get_session_cache('loginId')}`)){
                        this.opendiaflag = false
                        return
                    }
                    localStorage.setItem(`user_${get_session_cache('loginId')}`,JSON.stringify(this.history))
                    localStorage.setItem(`consumer_${get_session_cache('loginId')}`,JSON.stringify(this.selected))
                    location.reload() // 切换客户后刷新页面
                }else{
                    let msg = this.$i18n.locale == 'zh' ? res.message : res.enMessage;
                    this.msgerror(msg)
                }
            })
        },
        selectList(item,index){
            if(this.actList == index) return
            this.actHis = -1;
            this.actList = index;
            this.selected = item;
            this.btndisable = false;
        },
        selectHis(item,index){
            if(this.actHis == index) return
            this.actList = -1
            this.actHis = index;
            this.selected = item;
            this.btndisable = false;
        },
        putHistory(selected){
            const id = this.selected.userId;
            const isSame = (sel) => sel.userId === id;
            if(this.history.some(isSame)) return
            this.history.unshift(selected)
            if(this.history.length >=6){
                this.history.pop()
            }
        },
        getUserList(){
            this.listLoading = true
            $http("get", "customerInfo/getCustomers")
            .then((res)=>{
                if(res.status === "SUCCESS" && res.data){
                    this.searchGather = Object.freeze(res.data);
                    this.userList = Object.freeze(res.data);
                    if(this.userList.length > 0 && this.history.length > 0){
                        let temp = [];
                        this.userList.forEach((user)=>{
                            this.history.forEach((item)=>{
                                if(user.userId == item.userId){
                                    temp.push(user);
                                }
                            })
                        })
                        this.history = temp;
                    }
                    // 如何将下面代码放到上面就可以让用户点击一次 看到引导页
                    if(this.userList.length === 1){ // 如何运维客户只有一个时，直接选中进入刷新
                        this.selectList(this.userList[0],0)
                        this.imsure()
                    }
                }else if(res.status === "NORESOURCES"){
                    this.searchGather = [];
                    this.userList = [];
                    this.history = [];
                }else if(res.status === "ERROR"){
                    this.searchGather = [];
                    this.userList = [];
                    this.history = [];
                    let msg = this.$i18n.locale == 'zh' ? res.message : res.enMessage;
                    this.msgerror(msg)
                }
                this.listLoading = false
            })
        }
    },
    // 后台需提供登录用户类型，和用户id。
    created(){
        const localHistory = localStorage.getItem(`user_${get_session_cache('loginId')}`) // 获取最近访问list
        const loginType = get_session_cache('loginType') // 获取用户类型
        const consumer = localStorage.getItem(`consumer_${get_session_cache('loginId')}`)
        if(localHistory != null){
            this.history = JSON.parse(localHistory)
        }
        if(!consumer && loginType == 1008002){ // 当登录账号是运维类型时
            this.opendiaflag = true;
        }else{
            this.opendiaflag = false;
            this.btndisable = true;
        }
        if(loginType == 1008002){
            this.getUserList()
        }
        across.$off('openFromHeader')
        across.$on('openFromHeader',(boolean)=>{
            this.opendiaflag = boolean;
            // 再次打开要回显高亮客户并从storage中获取上次选中的consumer
            const consumer = localStorage.getItem(`consumer_${get_session_cache('loginId')}`)
            if(!!consumer){
                this.closeIcon = true;
                this.btndisable = false;
                this.selected = JSON.parse(consumer)
                this.actList = -1;
                this.actHis = -1;
                this.userList.forEach((ele,index)=>{
                    if(ele.userId === JSON.parse(consumer).userId){
                        this.actList = index;
                    }
                })
            }
        })
    },
}
</script>

<style lang="less" scoped>
.devops{
    .topcontain{
        padding-left: 20px;
        padding-top: 20px;
        border-bottom: 1px solid #dadada;
        .searchinp{
            width: 250px;
        }
        .listbox{
            width: 100%;
            height: 225px;
            margin-top: 20px;
            overflow: hidden;
            overflow-y: auto;
            &::-webkit-scrollbar{
                width: 4px;
            }
            &::-webkit-scrollbar-thumb{
                border-radius: 10px;
                box-shadow: inset 0 0 5px rgba(24,25,27, 0.2);
                background: rgba(24,25,27, 0.2);
            }
            &::-webkit-scrollbar-track{
                box-shadow: inset 0 0 5px rgba(24,25,27, 0.1);
                background: rgba(24,25,27, 0.1);
                border-radius: 0;
            }
        }
    }
    .botcontain{
        padding-left: 20px;
        p{
            line-height: 40px;
        }
    }
    ul{
        display: flex;
        flex-wrap: wrap;
        li{
            border: 1px solid #dadada;
            box-sizing: border-box;
            padding: 0px 15px;
            margin-right: 10px;
            line-height: 28px;
            margin-bottom: 15px;
            cursor: pointer;
            &:hover{
                color: #4980d7;
                border-color: #4980d7;
            }
            &.active{
                color: #fff;
                background: #4980d7;
                border-color: #4980d7;
            }
            span{
                color: #F56C6C;
                line-height: 0;
                vertical-align: -3px;
            }
        }
    }
    /deep/.el-dialog__body{
        padding: 0;
    }
    .el-dialog__wrapper{
        z-index: 9000 !important;
    }
}
.theme2 .devops ul li{
    border-color: #494949;
}
</style>